/* eslint-disable */

import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { change, getFormValues, reduxForm } from 'redux-form';
import { Input } from '../../../../UI/InputElement/InputElement';
import isEmpty from '../../../../../../utility/IsEmptyValidator';
import { convertDateFormatV4, convertTo24HourFormat, getConvertTo12Hours, makeFirstLetterCapital } from '../../../../../../utility/utility';
import { DateTimeField } from '../../../../UI/DateTimeField/DateTimeField';
import { newShiftFormValidator as validate } from '../../../../../../utility/validator/validator';
import ShiftFormSkeleton from './ShiftFormSkeleton';
import ShiftOverriddenWarningModal from './ShiftOverriddenWarningComponent/ShiftOverriddenWarningModal';
import moment, { min } from "moment";
import cloneDeep from 'clone-deep';
import { height, minHeight } from '@mui/system';
import { toast } from 'react-toastify';
import ErrorAlert from '../../../../../../utility/errorHandler/errorAlert';
import { convertDateUTCFormAuditToSelectedTimezone, tzUTCDateConverterTool_V2, tzUTCDateTimeZoneConverterTool_V2, tzUTCTimeTimeZoneActualTime, tzUTCTimeToActualTime } from '../../../../../../utility/TimezoneOperations/timezoneUtility';
import { get } from 'jquery';

// import $ from 'jquery';
// $(document).ready(function() {
//     $('#').trigger('click');
// });

let NewShiftForm = (props) => {
    
    const ShiftOrigin  = props.formStates && props.formStates.shiftOrigin;
    console.log(ShiftOrigin,"ShiftOrigin");
    
    
    let fetchedJobAddressStorage = [];
    const [selectedJobsAddressList, setSelectedJobsAddressList] = useState([]);
    const [selectedFlUserId, setSelectedFlUserId] = useState(null);
    const [slotsAvaliable, setSlotsAvailiable] = useState(null);
    const [timeData, setTimeData] = useState({});

    let flUser = null;
    if (props && props.history && props.history.location && props.history.location.state && props.history.location.state.frontlineUser) {
        flUser = props.history.location.state.frontlineUser
    }   


    let shiftAvaliablityDays = [];
    let shiftAvaliablitysSlots = [];
    console.log("shiftAvaliablitysSlots", slotsAvaliable);
    

    if (props?.FLShiftDetailBasedAvalibality && props?.FLShiftDetailBasedAvalibality.length > 0) {
        debugger
        props?.FLShiftDetailBasedAvalibality.forEach(item => {
            const day = makeFirstLetterCapital(item.day);
            
            const exists = shiftAvaliablityDays.some(existingItem => existingItem.value === item.day);
            
            if (!exists) {
                shiftAvaliablityDays.push({
                    label: day,
                    value: item.day,
                });
            }
        });
    }




    useEffect(() => {
        if (props.isEditFLShiftForm && props.isEditFLShiftForm == true) {

            if (props.jobAccountSitesList && props.jobAccountSitesList.length > 0) {
                props.jobAccountSitesList && props.jobAccountSitesList.reduce((acc, curr, index) => {

                    props.formStates && props.formStates.shiftOrigin && props.formStates.shiftOrigin.accountIds && props.formStates.shiftOrigin.accountIds.map((e) => {
                        if (e.value == curr.id) {
                            fetchedJobAddressStorage.push(curr);
                        }
                    })

                    return acc;

                }, [])
                setSelectedJobsAddressList(fetchedJobAddressStorage);
            }

        }
    }, [props.jobAccountSitesList])


    const getFrontlineUsersList = (frontlineUsersList) => { 
        if (props.frontlineUsersList && props.frontlineUsersList.length > 0) {
            return frontlineUsersList && frontlineUsersList.map((data) => {
                return {
                    value: data.id,
                    label: data.first_name + ' ' + data.last_name,

                }
            })
        } else {
            return []
        }
    };

    const getJobAccountSitesList = (jobAccountSitesList) => {
        if (props.jobAccountSitesList && props.jobAccountSitesList.length > 0) {
            return jobAccountSitesList && jobAccountSitesList.map((data) => {
                return {
                    value: data.id,
                    label: data.name,
                    address: data.address,
                    timezone: data.timezone,
                }
            })
        } else {
            return []
        }
    };

    

    const [frontlineUsersList, setFrontlineUsersList] = useState(getFrontlineUsersList(props.frontlineUsersList));
    const [jobSitesList, setJobSitesList] = useState(getJobAccountSitesList(props.jobAccountSitesList));
    
    const [addExistItemSlots, setAddExistItemSlots] = useState([{day:'',start_time:'',end_time:''}]);
    
    
    useEffect(() => {
        setFrontlineUsersList(getFrontlineUsersList(props.frontlineUsersList))
    }, [props.frontlineUsersList]);

    useEffect(() => {
        setJobSitesList(getJobAccountSitesList(props.jobAccountSitesList))
    }, [props.jobAccountSitesList]);

    useEffect(()=> {
        if(flUser?.id)
        {
            props.getSelectedFLUserJobs(flUser?.id)
            setSelectedFlUserId(flUser?.id)
        }
    },[flUser])

    const noOptionsMessage = (a, b) => {
        return 'No options';
    }
    // create new slots for exist item
    const handleCreateExistItemSlots = (index) => {
        
        let slots = [...props?.formStates?.shiftOrigin?.items];
        slots.push({
            days: '',
            start_time: '',
            end_time:'',
            is_overnight:null,
        });
        setAddExistItemSlots(slots);
        props.change(`shiftOrigin.items`, slots)
        setTimeout(() => {
            let ele = document.getElementById(`triggerPoint-${slots.length - 1}`)
            if (ele) {
                ele.click();
            }
        }, 100);
    }
    //delete the a slots for exist item
    const handleDeleteExistItemSlots = (index) => {
        let itemSlots = [...props?.formStates?.shiftOrigin?.items];
        itemSlots.splice(index, 1);
        setAddExistItemSlots(itemSlots);
        props.change(`shiftOrigin.items`, itemSlots)
    };
    // check slot is fill or not.
    const checkTimeField = (index) => {
        const start =  ShiftOrigin?.items[index]?.start_time;
        const end =   ShiftOrigin?.items[index]?.end_time;
        const days = ShiftOrigin?.items[index]?.days?.value;

        if(start && end && days){
         return true
        }else{
         return false
        }
     }

     // Convert time string like "12:30 AM" to minutes since midnight for easy comparison
     const convertTimeToMinutes = (timeString) => {
        if (!timeString) return null;
        
        // Extract hours, minutes, and period (AM/PM)
        const timeParts = timeString.match(/(\d+)[.:](\d+)\s*(AM|PM)/i);
        if (!timeParts) return null;
        
        let hours = parseInt(timeParts[1], 10);
        const minutes = parseInt(timeParts[2], 10);
        const period = timeParts[3].toUpperCase();
        
        // Convert to 24-hour format
        if (period === 'PM' && hours < 12) {
            hours += 12;
        } else if (period === 'AM' && hours === 12) {
            hours = 0;
        }
        
        // Return total minutes since midnight
        return hours * 60 + minutes;
    };
    
    // Handle overnight shifts by adding 1440 minutes (24 hours) to end time
    const adjustForOvernightShift = (startMinutes, endMinutes) => {
        if (endMinutes < startMinutes) {
            return { 
                adjustedEndMinutes: endMinutes + 1440,
                isOvernight: true 
            };
        }
        
        return { 
            adjustedEndMinutes: endMinutes,
            isOvernight: false 
        };
    };

     // Generic onChange handler that routes to the appropriate specific handler
     const handleTimeChange = (value, index, fieldName) => {
        if (fieldName.includes('days')) {
            return handleDaysChange(value, index);
        } else if (fieldName.includes('start_time')) {
            return handleStartTimeChange(value, index);
        } else if (fieldName.includes('end_time')) {
            return handleEndTimeChange(value, index);
        }
        return false;
    };

     const handleDaysChange = (value, index) => {debugger
        const selectedDay = value;

        if (!selectedDay) {
            return false;
        }

        const getDaysBasedItems = props?.FLShiftDetailBasedAvalibality?.filter((item) => item?.day === selectedDay?.value)

        setSlotsAvailiable(getDaysBasedItems)
    
    };
    
    const handleStartTimeChange = (value, index) => {
        const selectedDay = ShiftOrigin?.items[index]?.days?.value;
        const selectedStartTime = value;
        const selectedEndTime = ShiftOrigin?.items[index]?.end_time;
        
        if (!selectedDay) {
            return false;
        }

        if(selectedEndTime)
        {

            // Check if the shift is overnight (spanning AM to PM)
            const startMinutes = convertTimeToMinutes(selectedStartTime);
            const endMinutes = convertTimeToMinutes(selectedEndTime);
        
            const { isOvernight } = adjustForOvernightShift(startMinutes, endMinutes);
    
            setTimeout(() => {
                const updatedItems = props.formStates.shiftOrigin.items.map((item, idx) => {
                    if (idx === index && selectedDay && selectedStartTime && selectedEndTime) {
                        return { ...item, start_time: selectedStartTime, is_overnight: isOvernight };
                    }
                    return item;
                });
        
                props.change('shiftOrigin.items', updatedItems);
            }, 0);

        }
    };
        
        const handleEndTimeChange = (value, index) => {
            const selectedDay = ShiftOrigin?.items[index]?.days?.value;
            const selectedEndTime = value;
        
            if (!selectedDay) {
                return false;
            }
        
            // Get the start time
            const selectedStartTime = ShiftOrigin?.items[index]?.start_time;
            
            // Check if the shift is overnight (spanning AM to PM)
             // Convert times to minutes
            const startMinutes = convertTimeToMinutes(selectedStartTime);
            const endMinutes = convertTimeToMinutes(selectedEndTime);
          
            // Check if the shift is overnight (end time earlier than start time)
            const { isOvernight } = adjustForOvernightShift(startMinutes, endMinutes);
      
            // Update the end_time and set is_overnight flag
            setTimeout(() => {
                const updatedItems = props.formStates.shiftOrigin.items.map((item, idx) => {
                    if (idx === index && selectedDay && selectedStartTime && selectedEndTime) {
                        return { ...item, end_time: selectedEndTime, is_overnight: isOvernight };
                    }
                    return item;
                });
        
                props.change('shiftOrigin.items', updatedItems);
            }, 0);
          
        };


    //hanlde chnage Date 
    const handleDateChange = (value) => {
        if(!props.formStates.shiftOrigin.start_date || !selectedFlUserId || !selectedJobsAddressList?.length)
        {
            return false
        }

        if(props.formStates.shiftOrigin && props.formStates.shiftOrigin.start_date && value && selectedFlUserId && selectedJobsAddressList?.length > 0)
        {
            props.getShiftDetailForSingleFLUser({
                user_id: selectedFlUserId,
                from: tzUTCDateTimeZoneConverterTool_V2(convertDateFormatV4(props?.formStates?.shiftOrigin?.start_date),selectedJobsAddressList[0]?.timezone, 'from'),
                to: tzUTCDateTimeZoneConverterTool_V2(convertDateFormatV4(value), selectedJobsAddressList[0]?.timezone, 'to'),
                timezone: selectedJobsAddressList[0]?.timezone,
              });
        }
    }



    const handleChangeFLUser = (flUser) => {
        props.getSelectedFLUserJobs(flUser.value);
        setSelectedFlUserId(flUser.value);

    }
    
    
    
        

    const { handleSubmit, pristine, reset, submitting, error, submitFailed } = props;

    if (props.isUpdateFLShiftForm) {
        return (
            <ShiftFormSkeleton />
        )
    } else {
        return (
            <>
                <main className="app-content wraper_content user_newQuote add_account_modal add_New_Accont add_newAccount">
                    <div className="inspection_content_sec appcontent_Inner">
                        <div className="container-fluids">
                            <div className="quote_form ticket_form" style={{ maxWidth: '800px' }}>
                                <div className="row">
                                    <div className="col-sm-12 text-center"> <h2 className="md_title" >{props.isEditFLShiftForm ? "Update Shift" : "New Shift"}</h2></div>
                                </div>
                                <div className="addQuote_form">
                                    <form className="form_content" onSubmit={handleSubmit} >
                                        <div className="cst_tab_content">

                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label className="form_title fw-bold"> Frontline User <sup className="cst_sup_txt text_danger">*</sup></label>
                                                        {flUser && flUser.id ? (
                                                            <input type="text" className="form-control input-modifier" placeholder={flUser.first_name + ' ' + flUser.last_name} disabled />
                                                        ) : (
                                                            <Input name="shiftOrigin[user_id]" dataTest="select_leave_type" type="inputSelect" options={frontlineUsersList} onChange={(flUser) => { handleChangeFLUser(flUser) }} placeholder="Please select" />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row mb-3">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label className="form_title fw-bold"> Job <sup className="cst_sup_txt text_danger">*</sup></label>
                                                        <Input
                                                            name="shiftOrigin[accountIds]"
                                                            isMulti={true} dataTest="select_leave_type"
                                                            noOptionsMessage={noOptionsMessage}
                                                            type="inputSelect"
                                                            onChange={(selectedJobsInfo) => {
                                                                setSelectedJobsAddressList(selectedJobsInfo);
                                                            }}
                                                            options={jobSitesList}
                                                            placeholder={jobSitesList && jobSitesList.length > 0 ? "Please select" : "To obtain job details, choose a Frontline user"}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {selectedJobsAddressList && selectedJobsAddressList.map((job, index) => {
                                                if (job && job.address && job.address.zip.length > 0) {
                                                    return (
                                                        <>
                                                            <div className="row" key={index}>
                                                                <div className="col-md-12">
                                                                    <div className="form-group">
                                                                        <label className="form_title fw-bold"> {job.label ? job.label : job.name} </label>
                                                                        <input
                                                                            name="shiftOrigin[jobAddress]"
                                                                            dataTest=""
                                                                            type="text"
                                                                            className="form-control input_modifier"
                                                                            placeholder={`${job.address.state + ', ' + job.address.country + ', ' + job.address.zip}`}
                                                                            disabled={true}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    );
                                                } else {
                                                    return (
                                                        <>
                                                            <div className="row" key={index}>
                                                                <div className="col-md-12">
                                                                    <div className="form-group">
                                                                        <label className="form_title fw-bold"> {job.label} </label>
                                                                        <input
                                                                            name="shiftOrigin[jobAddress]"
                                                                            dataTest=""
                                                                            type="text"
                                                                            className="form-control input_modifier"
                                                                            placeholder='No Address'
                                                                            disabled={true}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    );
                                                }
                                            })}

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className="form_title fw-bold"> From Date <sup className="cst_sup_txt text_danger">*</sup></label>
                                                        <div className="input-group cst_input_group col-lg-14 pl-0">
                                                            <div style={{ width: '100%' }}>
                                                                <Input
                                                                    name="shiftOrigin[start_date]"
                                                                    type="date"
                                                                    datePickerType={"react-datepicker"}
                                                                    minDate={new Date()}
                                                                    dateFormat="MM-dd-yyyy"                                                                        

                                                                    className="form-control input-modifier"
                                                                    placeholder="Select Date"
                                                                />
                                                            </div>
                                                            <div className="input-group-append cursor-pointer" style={{ float: "right", position: "absolute", right: 0, height: "45px", top: 0 }}>
                                                                <span class="input-group-text" id="basic-addon2"> <i class="fa fa-calendar"></i> </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className="form_title fw-bold"> To Date <sup className="cst_sup_txt text_danger">*</sup></label>
                                                        <div className="input-group cst_input_group col-lg-14 pl-0">
                                                            <div style={{ width: '100%' }}>
                                                                <Input
                                                                    name="shiftOrigin[end_date]"
                                                                    type="date"
                                                                    onChange={(value) => handleDateChange(value)} 
                                                                    datePickerType={"react-datepicker"}
                                                                    minDate={props && props.formStates && props.formStates.shiftOrigin && props.formStates.shiftOrigin.start_date ? new Date(props && props.formStates && props.formStates.shiftOrigin && props.formStates.shiftOrigin.start_date) : new Date()}
                                                                    dateFormat="MM-dd-yyyy"
                                                                    className="form-control input-modifier"
                                                                    placeholder="Select Date"
                                                                />
                                                            </div>
                                                            <div className="input-group-append cursor-pointer" style={{ float: "right", position: "absolute", right: 0, height: "45px", top: 0 }}>
                                                                <span class="input-group-text" id="basic-addon2"> <i class="fa fa-calendar"></i> </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className="form_title fw-bold"> Start Time <sup className="cst_sup_txt text_danger">*</sup></label>
                                                        <DateTimeField name="shiftOrigin[start_time]" timeConstraints={{ minutes: { step: 5 } }} datePickerType='react-datetime' pickerType="timePicker" dataFormat="hh:mm A" className="form-control Input-modifier" id="startTime" />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className="form_title fw-bold"> End Time <sup className="cst_sup_txt text_danger">*</sup></label>
                                                        <DateTimeField name="shiftOrigin[end_time]" timeConstraints={{ minutes: { step: 5 } }} datePickerType='react-datetime' pickerType="timePicker" dataFormat="hh:mm A" className="form-control Input-modifier" id="endTime" />
                                                    </div>
                                                </div>
                                            </div> */}

                                            <div className='row'>
                                            {slotsAvaliable &&
                                                slotsAvaliable?.length > 0 &&
                                                slotsAvaliable?.map((item) =>
                                                    item?.slots?.map((slot, index) => {
                                                        const startTime = moment(slot.is_overwritten ? slot?.overwrite_data?.start : slot?.start).format("hh:mm A");
                                                        const endTime = moment(slot.is_overwritten ? slot?.overwrite_data?.end : slot?.end).format("hh:mm A");
                                                

                                                    return (
                                                        <div key={index} className="col-md-3 shift_time_container">
                                                        <p>{startTime} - {endTime}</p>
                                                        </div>
                                                    );
                                                    })
                                                )}
                                            </div>

                                            {/* Adding the multiple shift start and end time */}
                                            {addExistItemSlots.map((time, index) => {
                                                return (
                                                    <div className='row'>
                                                        <div className={ShiftOrigin?.items[index]?.is_overnight ? "col-md-3" : "col-md-3"}>
                                                                <div className="form-group">
                                                                    <label className="form_title fw-bold"> Days <sup className="cst_sup_txt text_danger">*</sup></label>
                                                                    <Input
                                                                        name={`shiftOrigin.items[${index}].days`}
                                                                        dataTest="select_leave_type"
                                                                        // noOptionsMessage={ShiftOrigin?.start_date && ShiftOrigin?.end_date ? "" : "No available options"}  
                                                                        options={shiftAvaliablityDays} 
                                                                        disabled={true} 
                                                                        type="inputSelect"
                                                                        onChange={(value) => handleTimeChange(value, index, `shiftOrigin.items[${index}].days`)}                                                                        placeholder="Days"
                                                                        className="days_select_container"
                                                                        />
                                                                </div>
                                                        </div>

                                                      

                                                        <div className={ShiftOrigin?.items[index]?.is_overnight !== null ? "col-md-3" : "col-md-4"}>
                                                        <div className="form-group">
                                                            <label for="email" className="form_title fw-bold"> Start Time <sup className="cst_sup_txt text_danger">*</sup></label>
            
                                                             <DateTimeField 
                                                                timeConstraints={{ minutes: { step: 1 } }} 
                                                                datePickerType='react-datetime' 
                                                                pickerType="timePicker" 
                                                                disabled={ShiftOrigin?.items[index]?.days?.value ? false : true}
                                                                dataFormat="hh:mm A" 
                                                                className="form-control Input-modifier" 
                                                                id="startTime" 
                                                                onChange={(value) => handleTimeChange(value, index, `shiftOrigin.items[${index}].start_time`)}                                                                maxTime={new Date().setHours(18, 0)} 
                                                                name={`shiftOrigin.items[${index}].start_time`}  
                                                            />
                                                        </div>
                                                        </div>
                                                        
                                                        <div className={ShiftOrigin?.items[index]?.is_overnight !== null ? "col-md-3" : "col-md-4"}>
                                                        <div className="form-group">
                                                            <label className="form_title fw-bold"> End Time <sup className="cst_sup_txt text_danger">*</sup></label>
                                                            
                                                                <DateTimeField 
                                                                    timeConstraints={{ minutes: { step: 1 } }} 
                                                                    datePickerType='react-datetime' 
                                                                    pickerType="timePicker" 
                                                                    disabled={ShiftOrigin?.items[index]?.days?.value ? false : true}
                                                                    dataFormat="hh:mm A" 
                                                                    className="form-control Input-modifier" 
                                                                    id="endTime" 
                                                                    onChange={(value) => handleTimeChange(value, index, `shiftOrigin.items[${index}].end_time`)}                                                          
                                                                    name={`shiftOrigin.items[${index}].end_time`} 
                                                            />
                                                        </div>
                                                        </div>

                                                        {ShiftOrigin?.items[index]?.is_overnight !== null && (
                                                            <div className="col-md-2" style={{marginTop:'40px', cursor:'pointer'}}>
                                                            <p style={{color:'#34B206'}}>{ShiftOrigin?.items[index]?.is_overnight ? 'Over Night' : 'Day'}</p>
                                                            </div>
                                                            
                                                        )}

                                                        {index === 0 ? (
                                                            <div className="col-md-1" style={{marginTop:'34px', cursor:'pointer'}}>
                                                                {checkTimeField(props?.formStates?.shiftOrigin?.items?.length - 1) ? (
                                                                    <img src='../images/icons/more.png'  alt='add-iocn' height={38} width={38} onClick={() => handleCreateExistItemSlots(index)} />
                                                                ) : (
                                                                    <img src='../images/icons/grey-more.png'  alt='add-iocn' height={38} width={38} />
                                                                )}
                                                            </div>
                                                        ) : (
                                                            <div className="col-md-1" style={{marginTop:'30px', cursor:'pointer', position:'relative', right:'10px'}}>
                                                                <button type="button" class="btn btn-dark" onClick={() => handleDeleteExistItemSlots(index)}><i className="far fa-trash-alt"></i></button>
                                                            </div>
                                                        )}
                                                    </div>
                                            )
                                        })}


                                            <div className="row mb-3">
                                                <div className="col-md-12">
                                                    <div className="group">
                                                        <label className="form_title fw-bold"> Notes <sup className="cst_sup_txt text_danger">*</sup></label>
                                                        <Input name="shiftOrigin[notes]" type="textarea" className="form-control textarea_modifier" rows="5" placeholder="Add your notes" />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="modal-footer">
                                            <button data-test="cancel_button" type="button" className="btn cst_btn btn-outline-secondary cancel_btnnew w-25" onClick={() => { props.onCancelClicked() }}>Cancel</button>
                                            <button data-test="submit_button" type="submit" disabled={props.isLoading} className={props.isLoading ? "btn cst_btn btn_danger btn-wait w-25" : "btn cst_btn btn_danger w-25"} >{props.isLoading ? "" : "Submit"}</button>
                                            <button
                                                type="button"
                                                className="d-none shiftOverriddenWarningModal"
                                                data-toggle="modal"
                                                data-target="#shiftOverriddenWarningModal"
                                                data-backdrop="static"
                                                data-keyboard="false"
                                                onClick={() => { props.handleFrequentTimeTracker_openModal(); }}
                                            />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </main >

                {props.isTimeTrackerModalOpen ? (
                    <ShiftOverriddenWarningModal {...props} />
                ) : null}
            </>
        );
    }

};

const mapStateToProps = (state, props) => {

    let shiftOrigin = {}

    const getAccountIdsInfo = (accounts) => {
        return accounts && accounts.map((res) => ({
            value: res.id,
            label: res.name,
            address: res.address,
        }));
    };

    const getAssignedFLUserInfo = (fluser) => {
        return {
            value: fluser.id,
            label: fluser.first_name + ' ' + fluser.last_name,
        }
    };

    // Default slot for dynamic items
    const defaultSlot = {
        days: "",
        start_time: '',
        end_time: '',
        is_overnight: null,
    };

    if (isEmpty(state.TimeTrackerModReducer.getShiftDetailOfSingleFLUser)) {
        let flUser = null;
        if (props && props.history && props.history.location && props.history.location.state && props.history.location.state.frontlineUser) {
            flUser = props.history.location.state.frontlineUser
        }
        shiftOrigin = {
            accountIds: [],
            user_id: flUser && flUser.id ? getAssignedFLUserInfo(flUser) : '',
            start_date: '',
            end_date: '',
            notes: '',
            items: [defaultSlot] 
        }
    } else {
        const value = cloneDeep(state.TimeTrackerModReducer.getShiftDetailOfSingleFLUser);

        shiftOrigin = {
            accountIds: value && value.accounts && value.accounts.length > 0 ? getAccountIdsInfo(value.accounts) : [],
            user_id: value && value.assignedTo && value.assignedTo.id ? getAssignedFLUserInfo(value.assignedTo) : '',
            start_date: value && value.start_date && value.start_date.length > 0 ? new Date(value.start_date) : '',
            end_date: value && value.end_date && value.end_date.length > 0 ? new Date(value.end_date) : '',
            // start_time: value && value.start_time && value.start_time.length > 0 ? getConvertTo12Hours(value.start_time) : '',
            // end_time: value && value.end_time && value.end_time.length > 0 ? getConvertTo12Hours(value.end_time) : '',
            notes: value && value.notes && value.notes.length > 0 ? value.notes : '',
            items: value && value.items && value.items.length > 0 ? [...value.items, defaultSlot] : [defaultSlot]

        }
    }

    return {
        initialValues: { shiftOrigin },
        formStates: getFormValues('newShiftForm')(state)
    }

}

NewShiftForm = reduxForm({
    form: 'newShiftForm',
    validate,
    enableReinitialize: true
})(NewShiftForm);

NewShiftForm = connect(mapStateToProps)(NewShiftForm)

export default NewShiftForm;